import { useMemo } from "react";

export const useHomeOrdersTabViewModel = ({ orders = [], milestones = [] }) => {
  const ordersWithMilestones = useMemo(() => {
    if (!orders.length || !milestones.length) {
      return [];
    }

    const flattenedOrders = [];

    orders.forEach((order) => {
      const associatedMilestones = [];

      // Find all milestones that contain an orderTemplate matching this order's orderTemplateId
      milestones.forEach((milestone) => {
        const hasMatchingOrderTemplate = milestone.orderTemplates?.some(
          (orderTemplate) => orderTemplate.id === order.orderTemplateId
        );

        if (hasMatchingOrderTemplate) {
          associatedMilestones.push(milestone);
        }
      });

      // Create a separate entry for each milestone the order belongs to
      if (associatedMilestones.length > 0) {
        associatedMilestones.forEach((milestone) => {
          flattenedOrders.push({
            ...order,
            milestones: associatedMilestones, // Keep all milestones for reference
            milestoneName: milestone.displayName || "Unknown Milestone",
            milestoneId: milestone.id,
            // Create unique ID to avoid conflicts when same order appears under multiple milestones
            uniqueId: `${order.id}-${milestone.id}`,
          });
        });
      } else {
        // Orders without milestones
        flattenedOrders.push({
          ...order,
          milestones: [],
          milestoneName: "Unknown Milestone",
          uniqueId: `${order.id}-unknown`,
        });
      }
    });

    return flattenedOrders;
  }, [orders, milestones]);

  return {
    ordersWithMilestones,
  };
};
